import * as React from 'react';

class PersonSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 20"
        fill="none"
        className={`svg-icon person-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M7 7C7.66751 7 8.32003 6.80206 8.87505 6.43121C9.43007 6.06036 9.86265 5.53326 10.1181 4.91656C10.3735 4.29986 10.4404 3.62126 10.3102 2.96657C10.1799 2.31189 9.85849 1.71052 9.38649 1.23852C8.91448 0.766514 8.31312 0.445076 7.65843 0.314851C7.00374 0.184626 6.32514 0.251462 5.70844 0.506908C5.09174 0.762354 4.56464 1.19494 4.19379 1.74995C3.82294 2.30497 3.625 2.95749 3.625 3.625C3.625 4.06821 3.7123 4.50708 3.88191 4.91656C4.05152 5.32603 4.30012 5.69809 4.61351 6.01149C5.24645 6.64442 6.10489 7 7 7V7ZM10.75 8.5H3.25C2.45435 8.5 1.69129 8.81607 1.12868 9.37868C0.566071 9.94129 0.25 10.7044 0.25 11.5V19C0.25 19.1989 0.329018 19.3897 0.46967 19.5303C0.610322 19.671 0.801088 19.75 1 19.75C1.19891 19.75 1.38968 19.671 1.53033 19.5303C1.67098 19.3897 1.75 19.1989 1.75 19V11.5C1.75 11.1022 1.90804 10.7206 2.18934 10.4393C2.47064 10.158 2.85218 10 3.25 10H10.75C11.1478 10 11.5294 10.158 11.8107 10.4393C12.092 10.7206 12.25 11.1022 12.25 11.5V19C12.25 19.1989 12.329 19.3897 12.4697 19.5303C12.6103 19.671 12.8011 19.75 13 19.75C13.1989 19.75 13.3897 19.671 13.5303 19.5303C13.671 19.3897 13.75 19.1989 13.75 19V11.5C13.75 10.7044 13.4339 9.94129 12.8713 9.37868C12.3087 8.81607 11.5456 8.5 10.75 8.5Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default PersonSvg;
